import { __rest } from "tslib";
import { createElement, forwardRef, Fragment } from 'rax';
import classNames from 'classnames';
import View from '../../view';
import Icon from '../../icon';
const Media = (props, ref) => {
    const { action, prefix = 'mt-', icon, children, className } = props, others = __rest(props, ["action", "prefix", "icon", "children", "className"]);
    return (<View ref={ref} {...others} className={classNames(`${prefix}list-item-media`, action ? `${prefix}list-item-media--last` : null, className)}>
      {icon ? <Icon className={`${prefix}list-item-icon`} name={icon}/> : null}
      <Fragment>{children}</Fragment>
    </View>);
};
export const ListItemMedia = forwardRef(Media);
const Action = (props, ref) => {
    return <ListItemMedia {...props} action ref={ref}/>;
};
export const ListItemAction = forwardRef(Action);
export default ListItemMedia;
